import { api } from '../utils/api' // Assuming global api instance exists
import { PaymentMethod } from '../types/payment-method'

export const getPaymentMethods = async (): Promise<PaymentMethod[]> => {
    const res = await api.get('/payment-methods')
    return res.data
}

export const createPaymentMethod = async (data: {
    name: string
    type: string
}): Promise<PaymentMethod> => {
    const res = await api.post('/payment-methods', data)
    return res.data
}

export const togglePaymentMethod = async (id: string): Promise<PaymentMethod> => {
    const res = await api.put(`/payment-methods/${id}/toggle`)
    return res.data
}

export const deletePaymentMethod = async (id: string): Promise<void> => {
    await api.delete(`/payment-methods/${id}`)
}
